import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { LangProvider } from "@/i18n";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Portfolio from "@/pages/Portfolio";
import Admin from "@/pages/Admin";

const SessionHandler = () => {
  const { processSession } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    const hash = window.location.hash || "";
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.slice(1)).get("session_id");
      const clean = () =>
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
      if (sid) {
        processSession(sid)
          .then((u) => {
            clean();
            if (u.is_admin) navigate("/admin");
          })
          .catch(clean);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};

function App() {
  return (
    <div className="App grain">
      <LangProvider>
        <BrowserRouter>
          <AuthProvider>
            <SessionHandler />
            <Routes>
              <Route path="/" element={<Portfolio />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" />
      </LangProvider>
    </div>
  );
}

export default App;
